import ProcessPanelLayout1 from "../Templates/Layout1";
import { closeIndexedMeshDialog} from 'store/main/viewObjects';
import { useSelector} from 'react-redux';
import { RootState } from 'store';


function IndexedMesh(props:any) {
    const {project, catalogId, name, file_type, source_type, isFolder} = props;
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const {imstate:open } = viewObject;

    return (
      <ProcessPanelLayout1 
        project={project}
        catalogId={catalogId}
        name={name}
        file_type={file_type}
        source_type={source_type}
        closeDialog={closeIndexedMeshDialog}
        state={open}
        helpLinkCode="project-objects-indexed-mesh"
        isFolder={isFolder}
      />
  	)
}

export default IndexedMesh